/** @type {Record<string, string>} */
const validation = {
	required: 'This field is required',
	nomProjetInvalid: 'Invalid characters: only lowercase letters, numbers and hyphens are allowed',
	selectPays: 'You must select a country',
	siteWebUrl: 'Please enter a valid URL (e.g. https://example.com or http://www.example.com)',
	domaine: 'Please enter a valid domain name (e.g. example.com or sub.example.com)',
	email: 'Please enter a valid email address (e.g. name@example.com)',
	facebookUrl: 'Please enter a valid URL (e.g. https://www.facebook.com/mypage)',
	youtubeUrl: 'Please enter a valid URL (e.g. https://www.youtube.com/user/mychannel)',
	instagramUrl: 'Please enter a valid URL (e.g. https://www.instagram.com/myorg/)',
	xUrl: 'Please enter a valid URL (e.g. https://x.com/myorg)',
	typeLecture: 'Please select at least one read type',
	frontDomain: 'Please enter a valid domain name (e.g. pass.example.com)',
	facebookPassUrl: 'Please enter a valid URL (e.g. https://www.facebook.com/mypass)',
	youtubePassUrl: 'Please enter a valid URL (e.g. https://www.youtube.com/user/mypass)',
	instagramPassUrl: 'Please enter a valid URL (e.g. https://www.instagram.com/mypass/)',
	xPassUrl: 'Please enter a valid URL (e.g. https://x.com/MyPass)',
	urlFormulaire: 'Please enter a valid URL (e.g. https://pass.example.com/registration)',
	financeCurrencies: 'Select at least one currency',
	formuleFields: 'The package, reference, duration and period fields are required',
};

export default validation;
